
interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface ingredients {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    // ingredients: ingredients;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const malepackage: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} =
{
    "en": {
        "url": "male-fertility-package",
        "meta": {
            "title": "Male Fertility Package Dubai | Elite Body Home",
            "description": "Comprehensive male fertility testing and assessment in Dubai. Evaluate reproductive health with our specialized fertility package including semen analysis and hormone testing.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/male-fertility-package/",
            "og": {
                "title": "Male Fertility Package Dubai | Elite Body Home",
                "description": "Complete diagnostic package for male reproductive health assessment",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Male-Fertility-Dubai.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Male Fertility Package"],
        "hero": {
            "title": "Male Fertility Package",
            "subtitle": "Comprehensive Assessment for Reproductive Health",
            "description": "The Male Fertility Package at Elite Body Home Polyclinic is a comprehensive overview of common fertility challenges, assessment of reproductive health, and recommendations on effective treatment. Identifying potential causes of male fertility can increase the likelihood of conception, which is key when establishing a family. These structured diagnostic methods and therapeutic approaches are the basis of this new package to assist men in addressing reproductive health."
        },
        "howItWorks": {
            "title": "What is Included in Our Male Fertility Package",
            "description": "Our package includes essential tests to evaluate male reproductive health: SROU – Semen Analysis, TT — Testosterone Total, TESTF – Testosterone Free, FSH – Follicle Stimulating Hormone, LH – Luteinizing Hormone, PROLA – Prolactin."
        },
        "procedureSteps": {
            "heading": "Procedure",
            "para": "It contains a series of important diagnostic procedures to assess sperm health and identify male fertility problems.",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "Tailored advice based on medical history and lifestyle considerations.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Physical Examination",
                    "desc": "General health check to identify any physical factors impacting fertility.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "Semen Analysis",
                    "desc": "Comprehensive assessment of sperm count, motility and morphology.",
                    "icon": "fa-solid fa-microscope"
                },
                {
                    "title": "Hormonal Test",
                    "desc": "Blood work to assess important fertility hormones such as testosterone and FSH.",
                    "icon": "fa-solid fa-vial"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits",
            "subheading": "",
            "para": "The Fertility Package for Men has many benefits for men experiencing reproductive challenges or seeking to assess their fertility health preemptively.",
            "items": [
                {
                    "title": "Early Detection",
                    "desc": "Detecting fertility problems at an early stage can greatly improve treatment success.",
                    "icon": "fa-solid fa-search-plus"
                },
                {
                    "title": "Tailored Treatment Plans",
                    "desc": "Individual treatment options suggested based on diagnostics, from lifestyle adjustments to medical interventions.",
                    "icon": "fa-solid fa-clipboard-list"
                },
                {
                    "title": "Enhanced Reproductive Health",
                    "desc": "Improved sperm quality and reproductive function potentially increasing chance of conception.",
                    "icon": "fa-solid fa-baby"
                },
                {
                    "title": "Peace of Mind",
                    "desc": "Comprehensive look into fertility status with clear next steps.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "",
            "para": "The Fertility Package for Men is appropriate for any man who is concerned about his fertility or struggling with pregnancy with his partner.",
            "items": [
                {
                    "title": "Men Having Trouble Conceiving",
                    "desc": "If a couple has been attempting to conceive for more than a year without success.",
                    "icon": "fa-solid fa-question"
                },
                {
                    "title": "Men with Known Reproductive Issues",
                    "desc": "Conditions like varicoceles, hormonal imbalances, low sperm count, etc.",
                    "icon": "fa-solid fa-exclamation-triangle"
                },
                {
                    "title": "Men Preparing for Fertility Preservation",
                    "desc": "Essential assessment before sperm freezing for future use.",
                    "icon": "fa-solid fa-snowflake"
                },
                {
                    "title": "Men with Specific Medical Histories",
                    "desc": "Those who had treatments like chemotherapy or with family history of genetic conditions.",
                    "icon": "fa-solid fa-history"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "",
            "para": "Preparation prior to the Fertility Package for Men includes specific guidelines to ensure test results provide us with the best possible assessment.",
            "items": [
                {
                    "title": "Abstain from Ejaculation",
                    "desc": "Avoid ejaculation for 2-5 days before sperm analysis.",
                    "icon": "fa-solid fa-stopwatch"
                },
                {
                    "title": "Avoid Alcohol and Smoking",
                    "desc": "Both can compromise sperm quality, abstain before testing.",
                    "icon": "fa-solid fa-smoking-ban"
                },
                {
                    "title": "Stay Hydrated",
                    "desc": "Adequate hydration can boost sperm health and motility.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "Medication Disclosure",
                    "desc": "Inform doctor about any medications as they may affect results.",
                    "icon": "fa-solid fa-pills"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "After the tests are performed as a part of the Fertility Package for Men, patients will be provided with a detailed report on the findings.",
            "items": [
                {
                    "title": "Sperm Health Report",
                    "desc": "In-depth assessment of sperm count, motility, and morphology.",
                    "icon": "fa-solid fa-file-medical-alt"
                },
                {
                    "title": "Hormonal Balance",
                    "desc": "Results of hormone profile to determine any imbalances affecting fertility.",
                    "icon": "fa-solid fa-balance-scale"
                },
                {
                    "title": "Imaging Results",
                    "desc": "If structural issues like varicoceles are found, correction plan will be presented.",
                    "icon": "fa-solid fa-x-ray"
                },
                {
                    "title": "Treatment Recommendations",
                    "desc": "Personalized recommendations including lifestyle changes, medications or advanced fertility treatments.",
                    "icon": "fa-solid fa-hand-holding-medical"
                }
            ]
        },
        "aftercareTips": {
            "heading": "To Get the Male Fertility Package from Elite Body Home",
            "subheading": "",
            "para": "Elite Body Home provides you with medical and professional doctors, which first ensures possible diagnosis and treatment of male infertility. Our Male Fertility Package is all inclusive, featuring the latest advancements in semen analysis, expert hormone testing, and targeted consultations. At Innovative Health Center, we use the latest diagnostic tools and technologies to deliver precise results and customized treatment plans created just for you! We firmly believe in a compassionate and confidential approach to support you at every step of your fatherhood journey.",
            "items": []
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "Common questions about male fertility testing",
            "items": [
                {
                    "question": "How long does it take to complete the fertility tests?",
                    "answer": "The tests included in the Fertility Package for Men typically take 1-2 days to complete, with the results available within a week."
                },
                {
                    "question": "Can lifestyle affect male fertility?",
                    "answer": "Yes, lifestyle factors such as smoking, excessive alcohol consumption, and poor diet can significantly impact sperm quality and male fertility."
                },
                {
                    "question": "What if my semen analysis shows low sperm count?",
                    "answer": "If the results indicate a low sperm count, our fertility specialists will develop a personalized treatment plan, which may include lifestyle changes, medications, or other fertility treatments."
                },
                {
                    "question": "Is fertility testing painful?",
                    "answer": "The tests are generally non-invasive and painless. Semen analysis and blood tests require only sample collection, while ultrasound imaging involves minimal discomfort."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Male-Fertility-Package-scaled.jpg",
            "beforeAfter": []
        },
        "product": {
            "id": 14,
            "title": "Male Fertility Package in Dubai",
            "description": "Comprehensive diagnostic package for male reproductive health assessment",
            "price": 1200
        }
    },
    "ar": {
        "url": "male-fertility-package",
        "meta": {
            "title": "باقة فحص الخصوبة للرجال في دبي | ايليت بودي هوم",
            "description": "فحص شامل لخصوبة الرجال في دبي. تقييم الصحة الإنجابية مع باقة الخصوبة المتخصصة لدينا والتي تشمل تحليل السائل المنوي وفحص الهرمونات.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/male-fertility-package",
            "og": {
                "title": "باقة فحص الخصوبة للرجال في دبي | ايليت بودي هوم",
                "description": "حزمة تشخيصية كاملة لتقييم الصحة الإنجابية للرجال",
                "image": "https://www.elitebodyhome.com/images/male-fertility-og.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "باقة فحص الخصوبة للرجال"],
        "hero": {
            "title": "باقة فحص الخصوبة للرجال",
            "subtitle": "عزز خصوبتك، وغير مستقبلك",
            "description": "تقدم عيادات ايليت بودي هوم باقة شاملة للخصوبة مخصصة للرجال ومصممة لتقييم التحديات الشائعة في الخصوبة، وتقييم صحة الرجل الجنسية والإنجابية بدقة، وتقديم التوصيات العلاجية المناسبة. تُعد خصوبة الرجل عنصرًا أساسيًا في بدء تكوين الأسرة، حيث إن فهم الأسباب المحتملة لضعف الخصوبة يمكن أن يُحدث فرقًا كبيرًا في فرص الإنجاب. تجمع هذه الباقة بين تقنيات التشخيص الحديثة والخطط العلاجية المخصصة، لمساعدة الرجال على تعزيز صحتهم الإنجابية وتحقيق أفضل النتائج."
        },
        "howItWorks": {
            "title": "ما الذي تتضمنه باقة الخصوبة للرجال؟",
            "description": "تشمل باقة الخصوبة لدينا الفحوصات الأساسية لتقييم الصحة الإنجابية للرجال: تحليل السائل المنوي، تحليل هرمون التستوستيرون الكلي، تحليل هرمون التستوستيرون الحر، تحليل الهرمون المنبه للجريب، تحليل الهرمون اللوتيني، تحليل هرمون البرولاكتين."
        },
        "procedureSteps": {
            "heading": "الإجراء",
            "para": "تتضمن باقة خصوبة الرجال عدة خطوات تشخيصية رئيسية تهدف إلى تقييم صحة الحيوانات المنوية والكشف عن الأسباب التي قد تؤثر على الخصوبة.",
            "steps": [
                {
                    "title": "استشارة الطبيب",
                    "desc": "تُجرى استشارة طبية لتقييم التاريخ الطبي والعوامل المتعلقة بنمط الحياة.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "الفحص البدني",
                    "desc": "يُفحص المريض فحص عام لتحديد أي مشكلات جسدية قد تؤثر على الخصوبة.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "تحليل السائل المنوي",
                    "desc": "يُجرى تقييم مفصل لعدد الحيوانات المنوية، وحركتها، وشكلها.",
                    "icon": "fa-solid fa-microscope"
                },
                {
                    "title": "فحوصات الهرمونات",
                    "desc": "تُجرى فحوصات الدم لقياس هرمونات الخصوبة مثل هرمون التستوستيرون.",
                    "icon": "fa-solid fa-vial"
                }
            ]
        },
        "benefits": {
            "heading": "الفوائد",
            "subheading": "",
            "para": "توفر باقة خصوبة الرجال العديد من المزايا للرجال الذين يواجهون تحديات في الخصوبة أو يرغبون في تقييم صحتهم الإنجابية بشكل استباقي.",
            "items": [
                {
                    "title": "الكشف المبكر",
                    "desc": "يساعد التعرف المبكر على مشكلات الخصوبة بشكل كبير على فرص نجاح العلاج.",
                    "icon": "fa-solid fa-search-plus"
                },
                {
                    "title": "خطط علاجية مخصصة",
                    "desc": "تُقدم خيارات علاج فردية بناءً على نتائج الفحوصات، تتراوح بين تغييرات في نمط الحياة إلى تدخلات طبية.",
                    "icon": "fa-solid fa-clipboard-list"
                },
                {
                    "title": "تحسين الصحة الإنجابية",
                    "desc": "يمكن تحسين جودة الحيوانات المنوية ووظائف الجهاز التناسلي من خلال علاج مستهدف يعزز فرص الحمل.",
                    "icon": "fa-solid fa-baby"
                },
                {
                    "title": "راحة البال",
                    "desc": "توفر هذه الباقة تقييمًا شاملاً ومفصلًا للرجال القلقين بشأن خصوبتهم، مما يساعدهم على فهم حالتهم واتخاذ الخطوات المناسبة.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية",
            "subheading": "",
            "para": "تناسب باقة فحص الخصوبة للرجال من جميع الأعمار الذين يشعرون بالقلق بشأن خصوبتهم أو يواجهون صعوبات في الإنجاب مع شركائهم.",
            "items": [
                {
                    "title": "الرجال الذين يواجهون صعوبة في الإنجاب",
                    "desc": "إذا حاول الزوجان الحمل لأكثر من سنة دون نجاح، قد تكون خصوبة الرجل عاملاً مؤثرًا.",
                    "icon": "fa-solid fa-question"
                },
                {
                    "title": "الرجال الذين يعانون من مشكلات صحية تناسلية معروفة",
                    "desc": "مثل دوالي الخصية، واضطرابات هرمونية، أو انخفاض عدد الحيوانات المنوية، حيث يجعلهم ذلك من المرشحين المثاليين لهذه الباقة.",
                    "icon": "fa-solid fa-exclamation-triangle"
                },
                {
                    "title": "الرجال الذين يستعدون للحفاظ على الخصوبة",
                    "desc": "توفر هذه الباقة تقييمًا أساسيًا قبل تجميد الحيوانات المنوية للراغبين في حفظ الحيوانات المنوية للاستخدام المستقبلي.",
                    "icon": "fa-solid fa-snowflake"
                },
                {
                    "title": "الرجال الذين لديهم تاريخ طبي",
                    "desc": "يُفضل إجراء هذا التقييم لبعض الحالات مثل من خضعوا للعلاج الكيميائي أو من لديهم تاريخ من الأمراض الوراثية.",
                    "icon": "fa-solid fa-history"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "",
            "para": "يجب على المرضى اتباع بعض الإرشادات قبل إجراء باقة فحص خصوبة لضمان دقة نتائج الفحوصات وتحقيق تقييم أمثل.",
            "items": [
                {
                    "title": "تجنب القذف",
                    "desc": "يُنصح بالامتناع عن القذف لمدة 2 إلى 5 أيام قبل فحص السائل المنوي لضمان دقة عدد وجودة الحيوانات المنوية.",
                    "icon": "fa-solid fa-stopwatch"
                },
                {
                    "title": "الامتناع عن الكحول والتدخين",
                    "desc": "يؤثر الكحول والتدخين سلبًا على جودة الحيوانات المنوية؛ لذا يُفضل تجنبهما في الأيام التي تسبق الفحوصات.",
                    "icon": "fa-solid fa-smoking-ban"
                },
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "يساعد شرب كمية كافية من الماء على تحسين صحة وحركة الحيوانات المنوية.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "إبلاغ الطبيب بالأدوية",
                    "desc": "قد تؤثر بعض الأدوية على مستويات الهرمونات وجودة الحيوانات المنوية؛ لذا يجب مناقشة أي أدوية تتناولها مع الطبيب قبل الفحوصات.",
                    "icon": "fa-solid fa-pills"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "سيحصل المرضى على تقرير مفصل يوضح النتائج المكتشفة بعد الانتهاء من فحوصات باقة فحص خصوبة الرجال، كما سيتم مناقشة النتائج مع أخصائي الخصوبة الذي يشرح الخطوات التالية وخيارات العلاج المحتملة.",
            "items": [
                {
                    "title": "تقرير صحة الحيوانات المنوية",
                    "desc": "ستحصل على تقرير مفصل لعدد الحيوانات المنوية، وحركتها، وشكلها.",
                    "icon": "fa-solid fa-file-medical-alt"
                },
                {
                    "title": "توازن الهرمونات",
                    "desc": "ستوضح نتائج الهرمونات وجود أي اختلالات قد تؤثر على الخصوبة.",
                    "icon": "fa-solid fa-balance-scale"
                },
                {
                    "title": "نتائج التصوير الطبي",
                    "desc": "سيتم وضع خطة علاج مناسبة إذا تم الكشف عن مشكلات هيكلية مثل دوالي الخصية.",
                    "icon": "fa-solid fa-x-ray"
                },
                {
                    "title": "توصيات العلاج",
                    "desc": "تُقدم توصيات شخصية بناءً على نتائج الفحوصات، قد تشمل تعديل نمط الحياة، أو أدوية، أو علاج مثل الإخصاب في المختبر (IVF).",
                    "icon": "fa-solid fa-hand-holding-medical"
                }
            ]
        },
        "aftercareTips": {
            "heading": "لماذا يجب اختيار عيادات ايليت بودي هوم؟",
            "subheading": "",
            "para": "خبرة تمتد لأكثر من 25 عامًا. فريق طبي مؤهل. نتائج تركز على احتياجات العميل.",
            "items": []
        },
        "faqData": {
            "heading": "الأسئلة المكررة",
            "subheading": "أسئلة شائعة حول فحص خصوبة الرجال",
            "items": [
                {
                    "question": "كم من الوقت يستغرق إكمال فحوصات الخصوبة؟",
                    "answer": "عادةً ما تستغرق الفحوصات المدرجة في باقة خصوبة الرجال من يوم إلى يومين لإكمالها، مع توفر النتائج خلال أسبوع."
                },
                {
                    "question": "هل يمكن أن يؤثر نمط الحياة على خصوبة الرجل؟",
                    "answer": "نعم، يمكن أن تؤثر عوامل نمط الحياة مثل التدخين، والإفراط في استهلاك الكحول، والنظام الغذائي السيء بشكل كبير على جودة الحيوانات المنوية وخصوبة الرجل."
                },
                {
                    "question": "ماذا لو أظهر تحليل السائل المنوي انخفاض عدد الحيوانات المنوية؟",
                    "answer": "إذا أشارت النتائج إلى انخفاض عدد الحيوانات المنوية، فسيقوم أخصائيو الخصوبة لدينا بوضع خطة علاج شخصية، والتي قد تشمل تغييرات في نمط الحياة، أو أدوية، أو علاجات خصوبة أخرى."
                },
                {
                    "question": "هل فحص الخصوبة مؤلم؟",
                    "answer": "الفحوصات بشكل عام غير جراحية وغير مؤلمة. يتطلب تحليل السائل المنوي وفحوصات الدم فقط جمع العينات، بينما ينطوي التصوير بالموجات فوق الصوتية على حد أدنى من الانزعاج."
                }
            ]
        }
    }
}